<div class="product-image text-center">
    <img src="/assets/img/1.png" alt="">
</div>
